export default __webpack_public_path__ + "static/media/e12.570e3b72.jpg";